import React from 'react';
import type { ButtonV2Props, SpacingStackProps } from '@withjoy/joykit';
import { SpacingStack, ButtonV2 } from '@withjoy/joykit';

export const PrimaryCta = (props: ButtonV2Props) => (
  <ButtonV2
    {...props}
    intent="neutral"
    shape="rounded"
  />
);

export const SecondaryCta = (props: ButtonV2Props) => (
  <ButtonV2
    {...props}
    intent="neutral"
    shape="rounded"
    variant="outline"
  />
);

export const CtaGroup = (props: SpacingStackProps) => (
  <SpacingStack
    spacing={5}
    {...props}
  />
);
